import React, { useEffect, useState } from "react";
import { Button, Col, Row, Modal } from "react-bootstrap";
import styles from "./Profile.module.scss";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { getClinicInfo, resetUpdateHospitalFilesMessages, resetUpdateHospitalMessages, resetDeleteMessages } from "../../../store/slices/clinicSlice";
import { FaCloudDownloadAlt, FaTrashAlt } from "react-icons/fa";
import {
  updateHospitalInfo,
  updateHospitalInfoFiles,
  deleteHospitalInfoImage,
} from "../../../store/slices/clinicSlice";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";

const HospitalInformation = () => {
  const dispatch = useDispatch();
  const [isEditMode, setIsEditMode] = useState(false);
  const { clinicInfo, updateHospitalErrorMessage, updateHospitalSuccessMessage, updateHospitalFilesErrorMessage, updateHospitalFilesSuccessMessage, deleteHospitalImageSuccessMessage, deleteHospitalImageErrorMessage } = useSelector((state) => state.clinic);
  const { token, userInfo } = useSelector((state) => state.auth);
  const clinic = clinicInfo && clinicInfo?.length > 0 ? clinicInfo[0] : [];
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDeleteField, setSelectedDeleteField] = useState(null);
  const [clinicHosiptalInfoFormData, setClinicHosiptalInfoFormData] = useState({
    iso_certificate: "",
    web_address: "",
    supportEmail: "",
    supportPhone: "",
    headerOnPDF: false,
    photoInLabReport: false,
    isHomeDelivery: false,
    headerAlignment: "",
    displayISOlogo: false,
  });
  const [hospitalFileUpload, setHospitalFileUpload] = useState({
    waterMark: "",
    headerLogo: "",
    authorizedSignature: "",
    clinicSmallLogo: "",
    ISOLogo: "",
    NABLLogo: "", 
    pdfHeader: "",
  })
  const [previewImages, setPreviewImages] = useState({
    waterMark: null,
    headerLogo: null,
    authorizedSignature: null,
    clinicSmallLogo: null,
    ISOLogo: null,
    NABLLogo: null,
    pdfHeader: null,
  });
  const imageFields = [
    { id: 'headerLogo', name: 'Header Logo', previewKey: 'headerLogo' },
    { id: 'authorizedSignature', name: 'Authorized Signature', previewKey: 'authorizedSignature' },
    { id: 'clinicSmallLogo', name: 'Clinic Small Logo', previewKey: 'clinicSmallLogo' },
    { id: 'ISOLogo', name: 'ISO Logo', previewKey: 'ISOLogo' },
    { id: 'NABLLogo', name: 'NABL Logo', previewKey: 'NABLLogo' },
    { id: 'waterMark', name: 'Watermark', previewKey: 'waterMark' },
    { id: "pdfHeader", name: "PDF Header", previewKey: "pdfHeader" },
  ];
  useEffect(() => {
    if (clinic) {
      setClinicHosiptalInfoFormData({
        iso_certificate: clinic?.hospitalInfo?.iso_certificate || "",
        web_address: clinic?.hospitalInfo?.web_address || "",
        supportEmail: clinic?.hospitalInfo?.supportEmail || "",
        supportPhone: clinic?.hospitalInfo?.supportPhone || "",
        headerOnPDF: clinic?.hospitalInfo?.headerOnPDF || false,
        photoInLabReport: clinic?.hospitalInfo?.photoInLabReport || false,
        isHomeDelivery: clinic?.hospitalInfo?.isHomeDelivery || false,
        headerAlignment: clinic?.hospitalInfo?.headerAlignment || "",
        displayISOlogo: clinic?.hospitalInfo?.displayISOlogo || false,
      });
    }
  }, [clinic]);

  useEffect(() => {
    if (updateHospitalSuccessMessage) {
      showToastifySuccess(updateHospitalSuccessMessage);
      dispatch(resetUpdateHospitalMessages());
    }
    if (updateHospitalErrorMessage) {
      showToastifyError(updateHospitalErrorMessage);
      dispatch(resetUpdateHospitalMessages());
    }
    if (updateHospitalFilesSuccessMessage) {
      showToastifySuccess(updateHospitalFilesSuccessMessage);
      dispatch(resetUpdateHospitalFilesMessages());
    }
    if (updateHospitalFilesErrorMessage) {
      showToastifyError(updateHospitalFilesErrorMessage);
      dispatch(resetUpdateHospitalFilesMessages());
    }
     if (deleteHospitalImageSuccessMessage) {
    showToastifySuccess(deleteHospitalImageSuccessMessage);
    dispatch(resetDeleteMessages());
  }
  if (deleteHospitalImageErrorMessage) {
    showToastifyError(deleteHospitalImageErrorMessage);
    dispatch(resetDeleteMessages());
  }
  }, [dispatch, updateHospitalErrorMessage, updateHospitalSuccessMessage, updateHospitalFilesSuccessMessage, updateHospitalFilesErrorMessage,deleteHospitalImageSuccessMessage, deleteHospitalImageErrorMessage]);

  const handleEdit = (item) => {
    setIsEditMode((prevState) => !prevState);
    if (!isEditMode) {
      setClinicHosiptalInfoFormData({
        ...clinicHosiptalInfoFormData,
        web_address: item?.hospitalInfo
          ?.web_address,
        iso_certificate: item?.hospitalInfo?.iso_certificate,
        supportEmail: item?.hospitalInfo?.supportEmail,
        supportPhone: item?.hospitalInfo?.supportPhone,
      });
    }
  };

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    setClinicHosiptalInfoFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  const handleSelect = (selectedOption) => {
    setClinicHosiptalInfoFormData((prev) => ({
      ...prev,
      headerAlignment: selectedOption.value,
    }));
  };

  const handleImageUpload = (e) => {
    const { name, files } = e.target;
    if (files.length > 0) {
      const file = files[0];
      setHospitalFileUpload((prev) => ({
        ...prev,
        [name]: file,
      }));
      const previewUrl = URL.createObjectURL(file);
      setPreviewImages((prev) => ({
        ...prev,
        [name]: previewUrl,
      }));
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    const data = {
      clinicId: clinic?._id,
      ...clinicHosiptalInfoFormData,
      token,
    };
    try {
      await dispatch(updateHospitalInfo(data)).unwrap();
      setIsEditMode(false);
      setClinicHosiptalInfoFormData({
        iso_certificate: "",
        web_address: "",
        supportEmail: "",
        supportPhone: "",
        headerOnPDF: false,
        photoInLabReport: false,
        isHomeDelivery: false,
        headerAlignment: "",
        displayISOlogo: false,
      });
      await dispatch(getClinicInfo({ userId: userInfo?._id, token }));
    } catch (error) {
      console.error('Error updating hospital info:', error);
    }
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    await dispatch(updateHospitalInfoFiles({ clinicId: clinic?._id, ...hospitalFileUpload, token }));
    await dispatch(getClinicInfo({ userId: userInfo?._id, token }));
  };

  const openDeleteModal = (fieldName) => {
  setSelectedDeleteField(fieldName);
  setShowDeleteModal(true);
};

const closeDeleteModal = () => {
  setShowDeleteModal(false);
  setSelectedDeleteField(null);
};

const handleDeleteImage = async () => {
  if (!selectedDeleteField) return;
  const param = {
    clinicId: clinic?._id,
    fieldName: selectedDeleteField,
    token
  };
  try {
    await dispatch(deleteHospitalInfoImage(param)).unwrap();
    await dispatch(getClinicInfo({ userId: userInfo?._id, token }));
  } catch (error) {
    console.error("Error deleting hospital image:", error);
  } finally {
    closeDeleteModal();
  }
};
  return (
    <>
      <div className={styles["hospital-div"]}>
        {/* <Pagination activeMenu={{ name: "Hospital Information", url: "/hospital-information" }} motherMenu={{ name: "Settings", url: "/settings" }} pageHeading="Hospital Information"/> */}
        <Row>
          <Col md={5}>
            <div className={styles["input-div"]}>
              <label className="col-form-label"><h5>ISO CERTIFICATION :</h5></label>
              {isEditMode ? (
                <input
                  type="text"
                  className="form-control"
                  name="iso_certificate"
                  onChange={handleChange}
                  value={clinicHosiptalInfoFormData.iso_certificate}
                />
              ) : (
                <p>{clinic?.hospitalInfo?.iso_certificate || "NA"}</p>
              )}
            </div>
          </Col>
          <Col md={5}>
            <div className={styles["input-div"]}>
              <label className="col-form-label"><h5>Web Address :</h5></label>
              {isEditMode ? (
                <input
                  type="text" className="form-control" name="web_address" onChange={handleChange} value={clinicHosiptalInfoFormData.web_address} />
              ) : (
                <p>{clinic?.hospitalInfo?.web_address || "NA"}</p>
              )}
            </div>
          </Col>
          <Col md={2}>
            <div className="text-end mt-5">
              <Button onClick={() => handleEdit(clinic)}>Edit</Button>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={5}>
            <div className={styles["input-div"]}>
              <label className="col-form-label"><h5>Support Email :</h5></label>
              {isEditMode ? (
                <input
                  type="text"
                  className="form-control"
                  name="supportEmail"
                  onChange={handleChange}
                  value={clinicHosiptalInfoFormData.supportEmail}
                />
              ) : (
                <p>{clinic?.hospitalInfo?.supportEmail || "NA"}</p>
              )}
            </div>
          </Col>
          <Col md={5}>
            <div className={styles["input-div"]}>
              <label className="col-form-label"><h5>Support Phone :</h5></label>
              {isEditMode ? (
                <input
                  type="text"
                  className="form-control"
                  name="supportPhone"
                  onChange={handleChange}
                  value={clinicHosiptalInfoFormData.supportPhone}
                />
              ) : (
                <p>{clinic?.hospitalInfo?.supportPhone || "NA"}</p>
              )}
            </div>
          </Col>
        </Row>
      </div>
      <Row className={styles["hospital-row"]}>
        <Col xl={4} className={styles["hospital-col"]}>
          <div>
            <input type="checkbox" name="headerOnPDF" checked={clinicHosiptalInfoFormData.headerOnPDF} onChange={handleChange} />
            <span>Display Header on PDF</span>
          </div>
        </Col>
        <Col xl={4} className={styles["hospital-col"]}>
          <div>
            <input type="checkbox" name="photoInLabReport" checked={clinicHosiptalInfoFormData.photoInLabReport} onChange={handleChange} />
            <span>Photo in LabReport</span>
          </div>
        </Col>
        <Col xl={4} className={styles["hospital-col"]}>
          <div>
            <input type="checkbox" name="isHomeDelivery" checked={clinicHosiptalInfoFormData.isHomeDelivery} onChange={handleChange} />
            <span>If Home Delivery is Available :</span>
          </div>
        </Col>
        <Col xl={4} className={styles["header-alignment"]}>
          <Select type="checkbox" name="headerAlignment" placeholder="Header Alignment" className={styles["select-style"]} onChange={handleSelect}
            value={{
              label: clinicHosiptalInfoFormData.headerAlignment,
              value: clinicHosiptalInfoFormData.headerAlignment
            }}
            options={["left", "center", "right", "headerFullWidth"].map((item) => ({ label: item, value: item }))}
          />
        </Col>
        <Col xl={4} className={styles["hospital-col"]}>
          <div>
            <input type="checkbox" name="displayISOlogo" checked={clinicHosiptalInfoFormData.displayISOlogo} onChange={handleChange} />
            <span>Display ISOlogo :</span>
          </div>
        </Col>
        <div className="text-end mt-3">
          <Button className="p-2" onClick={handleUpdate}>
            Update
          </Button>
        </div>
      </Row>
      <Row className={styles["all-pdf-row"]}>
       {imageFields.map(({ id, name, previewKey }) => (
  <Col xl={4} className={styles["all-pdf-col"]} key={id}>
    <div className={styles["file-upload-wrapper"]}>
      <div className={styles["img-div"]}>
        {previewImages[previewKey] ? (
          <img
            src={previewImages[previewKey]}
            alt={`${name} Preview`}
            className={styles["image-preview"]}
          />
        ) : (
          clinic?.hospitalInfo?.[previewKey] && (
            <img
              src={clinic?.hospitalInfo?.[previewKey]}
              alt={name}
              className={styles["image-preview"]}
            />
          )
        )}

      </div>
      <input
        type="file"
        id={id}
        className={styles["file-upload"]}
        accept=".svg,.png,.jpg,.gif"
        name={id}
        onChange={handleImageUpload}
      />
      <label htmlFor={id} className={styles["file-label"]}>
        <span className={styles["upload-icon"]}><FaCloudDownloadAlt /></span>
        <span className={styles["upload-text"]}>Click to upload {name}</span>
        <span className={styles["file-formats"]}>
          SVG, PNG, JPG or GIF (max. 800x400px)
        </span>
      </label>
       {(previewImages[previewKey] || clinic?.hospitalInfo?.[previewKey]) && (
        <button type="button" className={styles["delete-btn"]} onClick={() => openDeleteModal(previewKey)}><FaTrashAlt /></button>
        )}
    </div>
  </Col>
))}
        <div className="text-end mt-5">
          <Button onClick={handleUpload}>Upload</Button>
        </div>
      </Row>
<Modal show={showDeleteModal} onHide={closeDeleteModal} centered>
  <Modal.Header closeButton>
    <Modal.Title>Confirm Delete</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    Are you sure you want to delete this image?
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={closeDeleteModal}>
      Cancel
    </Button>
    <Button variant="danger" onClick={handleDeleteImage}>
      Delete
    </Button>
  </Modal.Footer>
</Modal>

    </>
  );
};

export default HospitalInformation;
